/**
 * @generated SignedSource<<47982dbf97c084ffd0275d18a52368a7>>
 * @relayHash f57c8d5c718b93fa76a1a3703981eafe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae0eb3dd6f77fe84692bceb37b492d4d630f283db72031f4e4afd4ad3bb39950

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthUnifiedProfileRollingDateIntervalInput = "DAYS_1" | "DAYS_180" | "DAYS_270" | "DAYS_30" | "DAYS_365" | "DAYS_7" | "DAYS_90" | "%future added value";
export type OnboardingHubPageComponentQuery$variables = {
  cloudId: string;
  insightsEnabled: boolean;
  rollingIntervals: ReadonlyArray<GrowthUnifiedProfileRollingDateIntervalInput>;
};
export type OnboardingHubPageComponentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"InsightsPanel" | "OnboardingListTable">;
};
export type OnboardingHubPageComponentQuery = {
  response: OnboardingHubPageComponentQuery$data;
  variables: OnboardingHubPageComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "insightsEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rollingIntervals"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "date"
  },
  {
    "kind": "ScalarField",
    "name": "value"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "OnboardingListTable"
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "InsightsPanel"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "OnboardingHubPageComponentQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraOnboardingConfigConnection",
        "kind": "LinkedField",
        "name": "jira_onboardingConfigs",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraOnboardingConfigEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraOnboardingConfig",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "onboardingConfigAri"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetValues"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "insightsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "GrowthUnifiedProfileSiteProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_siteProfile",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "rollingIntervals",
                    "variableName": "rollingIntervals"
                  }
                ],
                "concreteType": "GrowthUnifiedProfileSiteOnboardingInsightsResult",
                "kind": "LinkedField",
                "name": "onboardingHubInsightsOverAll",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "totalViews"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "totalEngagements"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileEngagementsSeries",
                    "kind": "LinkedField",
                    "name": "engagementsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "rollingInterval"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileViewSeries",
                    "kind": "LinkedField",
                    "name": "viewsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "completionRate"
                  },
                  {
                    "concreteType": "GrowthUnifiedProfileCompletionSeries",
                    "kind": "LinkedField",
                    "name": "completionsSeries",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ae0eb3dd6f77fe84692bceb37b492d4d630f283db72031f4e4afd4ad3bb39950",
    "metadata": {},
    "name": "OnboardingHubPageComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1dfbf25107ad675ecd6b2ea633e0fb2b";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
